// Firebase web config. CommonJS rather than an ES module export so the
// maintenance scripts in ../../scripts (plain Node, no build step) can
// require the same values the app uses instead of keeping a second copy that
// silently drifts. These are public client identifiers, not secrets — access
// is controlled by Firestore rules.
module.exports = {
  apiKey: "AIzaSyCGJhStE4BsZOrp5FE7oa9Ifqi0g-7UJqw",
  authDomain: "arshipper-b7ef2.firebaseapp.com",
  projectId: "arshipper-b7ef2",
  storageBucket: "arshipper-b7ef2.firebasestorage.app",
  messagingSenderId: "57933836621",
  appId: "1:57933836621:web:3408370cbed3ca72ddc704",
  measurementId: "G-E9WELH89GY",
};
